export namespace WecomaConstants {
    export const COOKIE_EXPIRATION = 365;
    export const ALL_RECHECK_EXPIRATION = 30;
    export const SOME_RECHECK_EXPIRATION = 60;

    export const COOKIE_NAME = "cbasda";
    export const CONSENT_CACHE_COOKIE_NAME = "consents";
    export const WECOMA_AUTHKEY = "device";
    export const WECOMA_KEY_STORAGE = "wecoma-keys";

    export const WECOMA_CODE_DEH = "da";
    // Kasa wecoma portal is in reality DEH wecoma portal
    export const WECOMA_CODE_KASA = "sa";
}
